const isHomepage = window.location.pathname === '/';

$(document).ready(function () {
  const isProductPage = window.location.pathname.includes('/products/');
  let isVisionSeries = false;
  let isDirectConnect = false;

  if (isProductPage) {
    // Open recommended art size accordion
    document.querySelector('.accordion-item.product-artwork-size .item-header').click();
    
    // Check for vision series template
    isVisionSeries = document.querySelector('[data-vision-series-split-template]');
    
    // Check for direct connect template 
    isDirectConnect = document.querySelector('[data-direct-connect-template]');
  }

  // If neither vision series nor direct connect is found, remove optionSelections from localStorage
  if (!isVisionSeries && !isDirectConnect) {
    localStorage.removeItem("optionSelections");
  }
});


// Announcement Theme Action Script Begin
function hideAnnouncement() {
  const an = $('#shopify-section-static-announcement .announcement-bar');
  an.addClass('display-none');
}
// Announcement Theme Action Script End

$(document).ready(function() {
  // Mega menu product revuew script begin
  const navmenu = $('header.site-header ul.navmenu-depth-2 li.navmenu-item .product-megamenu-content .review');
  setTimeout(() => {
      navmenu.each(function() {
          const badge = $(this).find('.stamped-main-badge .stamped-badge-caption');
          const reviews = badge.data('reviews');
          badge.text('('+reviews+')');
      });
  }, 1000);
  
  if (isHomepage) {
    $('summary.navmenu-link').on('mouseover', function() {
      const $detailsWrapper = $(this).parents('details');
      $detailsWrapper.attr('open', '');
    });

    $('summary.navmenu-link').on('mouseleave', function(event) {
      const $detailsWrapper = $(this).parents('details');
      const isOverMegaMenu = event.relatedTarget.classList.contains('navmenu-item') || event.relatedTarget.classList.contains('navmenu-submenu') || event.relatedTarget.classList.contains('navmenu');
      if (!isOverMegaMenu) {
        $detailsWrapper.removeAttr('open');
      }
    });

    $('.navmenu-meganav-wrapper').on('mouseover', function() {
      const $detailsWrapper = $(this).parents('details');
      $detailsWrapper.attr('open', '');
    });

    $('.navmenu-meganav-wrapper').on('mouseleave', function() {
      const $detailsWrapper = $(this).parents('details');
      $detailsWrapper.removeAttr('open');
    });
  }

  // Mega menu product revuew script end

  // Homepage product revuew script begin
  const pd = $('.featured-custom-collection-section ul.collections li');
  setTimeout(() => {
      pd.each(function() {
          const badge = $(this).find('.stamped-main-badge .stamped-badge-caption');
          const reviews = badge.data('reviews');
          badge.text('('+reviews+')');
      });
  }, 1000);
  // Homepage product revuew script end

  const h = $('header.site-header');

  // Specific Product Search Script Begin
  h.on('click', '.btn-specific-product-filter', function() {
      $('header.site-header .specific-product-filter').removeClass('display-none');
      if (window.screen.width <= 1023) {
          $(".shopify-section").addClass('active-product-search');
      }
  });
  // Specific Product Search Script End


  // slider_with_text section Swiper Initial Script Begin
  var swiper = new Swiper(".slider_with_text-section .mySwiper", {
      pagination: {
        el: ".swiper-pagination",
          clickable: true,
      },
      autoplay: {
        delay: 3000
      }
  });
  //slider_with_text section Swiper Initial Script End

  // Reviews Section Script Begin
  function renderHtml(data) {
      var html = '<div class="reviews">';
      var left_html = '';
      var right_html = '';
      $.each(data, function(index, item){
          if(index < 2)
              left_html += '<div class="review">'+ $(item).html() +'</div>';
          else
              right_html += '<div class="review">'+ $(item).html() +'</div>';
          // html += '<div class="review">'+ $(item).html() +'</div>';
      });
      html += '<div class="left-reviews col-half">' + left_html + '</div>';
      html += '<div class="right-reviews col-half">' + right_html + '</div>';
      html += '</div>';
      return html;
  }
  if($(".slider_with_text-section .mySwiper").length > 0) {
      $('.reviews-section #review-pagination-container').pagination({
          dataSource: function(done) {
              let result = [];
              let reviews = $('#data-container .review');
      
              for (var i = 0; i < reviews.length; i++) {
                  result.push(reviews[i]);
              }
              done(result);
          },
          pageSize: 5,
          callback: function(data, pagination) {
              var html = renderHtml(data);
              $('#data-container').html(html);
          }
      });
  }
  // Reviews Section Script End

  // Hompage Product Over Roll Script Begin
  var p = $('.featured-custom-collection-section ul.collections li');
  p.on('mouseover', function(){
      const t = $(this);
      const src = t.find('.over-roll-data').attr('data-over-src');
      const title = t.find('.over-roll-data').attr('data-over-title');

      t.find('img').attr('src', src);
      t.find('h4.title').text(title);
  });
  p.on('mouseout', function(){
      const t = $(this);
      const src = t.find('.over-roll-data').attr('data-src');
      const title = t.find('.over-roll-data').attr('data-title');

      t.find('img').attr('src', src);
      t.find('h4.title').text(title);
  });
  // Hompage Product Over Roll Script End


// ================= Why-Situ Page Action Script============//
  // Why-Situ faq_with_image section Script Begin
  jQuery('.faq-width-image .titleWrapper').click(function(){
      jQuery('.faq-width-image .titleWrapper.active')
          .next('.faq-width-image div.descwrapper')
          .css('display', 'none');
      jQuery('.faq-width-image .titleWrapper.active')
          .removeClass('active')
          .addClass('inactive');
  var toggle = jQuery(this).next('.faq-width-image div.descwrapper');
  jQuery(toggle).slideToggle("slow");
});
  jQuery('.faq-width-image .inactive').click(function(){
  jQuery(this).toggleClass('inactive active');
});
  jQuery('.faq-width-image .active').click(function(){
  jQuery(this).toggleClass('inactive active');
});
  // Why-Situ faq_with_image section Script End
  
// ================= Why-Situ Page Action Script============//

// ================= Begin Product Page Custom Script =========//
// changeProductPrice();
// $('.product-main-content-section select[data-variant-option-index=0]').on('change', function() {
//     changeProductPrice();
// });
// function changeProductPrice() {
//     const product_price = $('.product-main-content-section select[data-variant-option-index=0]').val();
//     $('.product-main-content-section .product-form--atc-button.mdc-ripple-surface.mdc-ripple-upgraded').text(product_price);
// }
// ================= End Product Page Custom Script ===========//

// ================= Begin Product Quantity Script ===========//
  $('.product-main-content-section .num-in span').click(function () {
  var $input = $(this).parents('.num-block').find('input.in-num');
  if($(this).hasClass('minus')) {
      var count = parseFloat($input.val()) - 1;
      count = count < 1 ? 1 : count;
      if (count < 2) {
      $(this).addClass('dis');
      }
      else {
      $(this).removeClass('dis');
      }
      $input.val(count);
  }
  else {
      var count = parseFloat($input.val()) + 1
      $input.val(count);
      if (count > 1) {
      $(this).parents('.num-block').find(('.minus')).removeClass('dis');
      }
  }

  $input.change();
  return false;
  });
// ================= End Product Quantity Script =============//

  // Begin Product swiper-slide script 
  if($(".product-main-content-section .mySwiper").length > 0) {
      var swiper = new Swiper(".product-main-content-section  .mySwiper", {
          slidesPerView: 6,
          freeMode: true,
          pagination: {
          el: ".swiper-pagination",
          clickable: true,
          },
      });
  }

  if($(".related-product-section .mySwiper").length > 0) {
      var swiper = new Swiper(".related-product-section  .mySwiper", {
          slidesPerView: 5,
          spaceBetween: 20,
          freeMode: true,
          pagination: {
              el: ".swiper-pagination",
              clickable: true,
          },
          breakpoints: {
              375: {
                  slidesPerView: 1.5,
                  spaceBetween: 20,
              },
              425: {
                  slidesPerView: 1.5,
                  spaceBetween: 20,
              },
              768: {
                  slidesPerView: 2,
                  spaceBetween: 20,
              },
              1024: {
                  slidesPerView: 3,
                  spaceBetween: 20,
              },
              1200: {
                  slidesPerView: 4,
                  spaceBetween: 20,
              },
              1400: {
                  slidesPerView: 5,
                  spaceBetween: 20,
              }
          }
      });
  }

if($(".product-gallery-section .mySwiper").length > 0) {
      var swiper = new Swiper(".product-gallery-section  .mySwiper", {
          slidesPerView: 5,
          spaceBetween: 20,

          freeMode: true,
          pagination: {
              el: ".swiper-pagination",
              clickable: true,
          },
          breakpoints: {
              375: {
                  slidesPerView: 3,
                  spaceBetween: 20,
              },
              425: {
                  slidesPerView: 3,
                  spaceBetween: 20,
              },
              768: {
                  slidesPerView: 3,
                  spaceBetween: 20,
              },
              1024: {
                  slidesPerView: 3,
                  spaceBetween: 20,
              },
              1200: {
                  slidesPerView: 4,
                  spaceBetween: 20,
              },
              1400: {
                  slidesPerView: 5,
                  spaceBetween: 20,
              }
          }
      });
  }

  if($(".featured-product-section .mySwiper").length > 0) {
      var swiper = new Swiper(".featured-product-section  .mySwiper", {
          autoplay: {
              delay: 2000,
          },
          slidesPerView: 5,
          spaceBetween: 20,
          freeMode: true,
          pagination: {
              el: ".swiper-pagination",
              clickable: true,
          },
          breakpoints: {
              375: {
                  slidesPerView: 1.5,
                  spaceBetween: 20,
              },
              425: {
                  slidesPerView: 1.5,
                  spaceBetween: 20,
              },
              768: {
                  slidesPerView: 2,
                  spaceBetween: 20,
              },
              1400: {
                  slidesPerView: 3.5,
                  spaceBetween: 20,
              }
          }
      });
  }
  // End Product swiper-slide script
  setTimeout(() => {
      $('.product-reviews--content .stamped-summary-actions-newreview').text('+ Add Reviews');
  }, 2000);
});

// Art Selector's script is in static-search.liquid

$(document).ready(function() {

// Taxes modal

if (Shopify.country != 'US') {
  $('.cart-btn-international').on('click', function(event) {
    event.preventDefault();
    $('.taxes-modal__overlay').css('display', 'block');
});

  $('.product-form--atc-button').on('click', (event) => {
    setTimeout(() => {
      $('.cart-btn-international').on('click', function(event) {
    event.preventDefault();
    $('.taxes-modal__overlay').css('display', 'block');
});
    }, 1000);
  });

$('.taxes-modal__close-btn').on('click', function() {
  $('.taxes-modal__overlay').css('display', 'none');
});
}

// Currency switcher in header

$('.announcement-bar .shopify-cross-border').on('click', function() {
  const $currencySwitcher = $(this);
  $currencySwitcher.find('.disclosure-list').toggleClass('disclosure-open');
  $('.announcement-bar .shopify-cross-border .disclosure-list__item').on('click', function() {
      const ISOCode = $(this).data('value');
      const $countrySelector = $currencySwitcher.find('[name="country_code"]');
      $countrySelector.val(ISOCode);
      $currencySwitcher.find('.shopify-localization-form').submit();
  });
});

$(window).on('click', function(event) {
  const $currencySwitcher = $('.announcement-bar .shopify-cross-border');
  const inCurrencyContainer = $currencySwitcher.find(event.target).length > 0 ? true : false;
  if (!inCurrencyContainer) {
      $currencySwitcher.find('.disclosure-list').removeClass('disclosure-open');
  }
});

  let currentVariant = JSON.parse(document.querySelector('[data-section-type="static-product"]').innerText).current_variant;

if (meta.product) {
  document.querySelector('.mobile-show.product-review .stamped-product-reviews-badge.stamped-main-badge').style.display = 'none';
  const productData = JSON.parse(document.querySelector('[data-section-type="static-product"]').innerHTML).product;
  updatePowerOptionURL(currentVariant);

  let firstTimeUrl = document.URL;
  document.addEventListener('change', function() {
        let currentPageUrl = document.URL;
        let url = new URL(currentPageUrl);
        let isVariantUrl = url.searchParams.get("variant");
        currentPageUrl = isVariantUrl ? currentPageUrl : isVariantUrl;
        if(currentPageUrl && firstTimeUrl != currentPageUrl) {
            firstTimeUrl = currentPageUrl;
            
            const variantData = productData.variants.find((variant) => variant.id == isVariantUrl);
            currentVariant = variantData;
            const quantity = parseInt(document.querySelector('#product-quantity-input').value);
            updateBtnPrice(variantData, quantity);
            updatePowerOptionURL(currentVariant);
        }
  });
  
  document.querySelectorAll('.plus, .minus').forEach(item => {
    item.addEventListener('click', function() {
        const quantity = parseInt(document.querySelector('#product-quantity-input').value);
        updateBtnPrice(currentVariant, quantity);
      });
  });
  
  function updateBtnPrice(currVariant, quantity) {
            
    document.querySelector('.product-form--atc-button').innerHTML = `Add to cart`;
  }
  
  function updatePowerOptionURL(currentVariant) {
    if (!productData.title.toLowerCase().includes('vision series')) return;
    
    let siblingVariant = null;
    if (siblingVariants[currentVariant.id] != null) {
      siblingVariant = siblingVariants[currentVariant.id];
    }
  
    if (siblingVariant == null) return;
  
    const selectedBtn = document.querySelector('.hardwire-container .hardwire-selected');
    selectedBtn.setAttribute('href', `/products/${productData.handle}?variant=${currentVariant.id}`);
    
    const otherOptionBtn = document.querySelector('.hardwire-container a:not(.hardwire-selected)');
  
    let otherOptionHref = otherOptionBtn.getAttribute('href');
  
    otherOptionHref = otherOptionHref.split('?')[0] + `?variant=${siblingVariant}`;
    otherOptionBtn.setAttribute('href', otherOptionHref);
  }
  
  // Artwork height select for Vision series
  if (productData.title.includes('Vision Series') || productData.title.includes('ArtTrack') || productData.title.includes('Direct Connect')) {
    const artworkSelect = document.querySelector('.artwork-height-option');
    const sizeSelect = document.querySelectorAll('.options-selection__input-select')[1];
    const options = Array.from(sizeSelect.querySelectorAll('option'));
    const variantSelection = document.querySelector('variant-selection');
  
    artworkSelect.addEventListener('change', (event) => {
      // Gets the "data-up-to" attribute of the selected option by index
      const upTo = event.target.querySelectorAll('option')[event.target.selectedIndex].dataset.upTo;
      const filteredOptions = options.filter(option => option.value.includes(`${upTo}"T`));
      const selectedColorVal = document.querySelector('.options-selection__option-value-input:checked').value;
  
      if (sizeSelect.value.includes(`${upTo}"T`)) {
        const selectedOptVal = sizeSelect.value;
        rebuildSelect(sizeSelect, filteredOptions);
        const currVariant = meta.product.variants.find(variant => variant.public_title.includes(selectedOptVal));
        variantSelection.setAttribute('variant', currVariant.id);
     
        sizeSelect.value = selectedOptVal;
      }
      else if (artworkSelect.value === 'none') {
        rebuildSelect(sizeSelect, options);
        sizeSelect.value = options[0].value;
      } else {
        rebuildSelect(sizeSelect, filteredOptions);
          const currVariant = meta.product.variants.find(variant => variant.public_title.includes(filteredOptions[0].value));
          variantSelection.setAttribute('variant', currVariant.id);
          sizeSelect.value = filteredOptions[0].value;
      }
      sizeSelect.dispatchEvent(new Event('change'));
    });
  }
  
  function rebuildSelect(select, newOptions) {
    // Remove all options from select
    select.querySelectorAll('option').forEach(option => {
      option.remove();
    });
  
    // Append filtered options to select
    newOptions.forEach(option => {
      select.append(option);
    });
  }
  
  // Power option switcher
  $('.hardwire-container a').on('mouseover', function() {
    $('.hardwire-title__type').text($(this).data('type-title'));
  });
  
  $('.hardwire-container a').on('mouseout', function() {
    $('.hardwire-title__type').text($('.hardwire-selected').data('type-title'));
  });

  // ArtTrack color temperature switcher
 
  $('.arttrack-temperature select').on('change', function() {
    const handle = $('.arttrack-temperature select option:checked').data('handle');
    generateTempURL(currentProduct, currentVariant, handle);
  });

  function generateTempURL(productData, currentVariant, handle) {
    if (!productData.title.toLowerCase().includes('arttrack')) {
        return;
    }
  
    let url = '';
    if (productData.handle.includes('3000k')) {
      const matchedVariant = otherOption.variants.find((variant) => variant.sku.includes(currentVariant.sku));
      url = `/products/${otherOption.handle}?variant=${matchedVariant.id}`;
    } else {
        const matchedVariant = otherOption.variants.find(variant => variant.sku.includes(currentVariant.sku.replace('-27K', '')));
        url = `/products/${otherOption.handle}?variant=${matchedVariant.id}`;
    }
      window.location.href = url;
  }

// Rechargeable Micro Pro color temperature switcher
$(document).ready(function () {
  $('.micro-temperature select').on('change', function () {
    const selectedHandle = $(this).find('option:selected').data('handle');
    if (!selectedHandle || !currentVariant) return;

    // Step 1: Strip temperature suffix from current SKU
    const baseSku = currentVariant.sku.replace(/-(27K|30K|40K)$/, '');

    // Step 2: Get the target product
    const targetProduct = allProducts[selectedHandle];
    if (!targetProduct) return;

    // Step 3: Filter variants that contain the base SKU
    const candidates = targetProduct.variants.filter(v => v.sku.includes(baseSku));

    // Step 4: Among candidates, find the variant that matches all options
    const matchedVariant = candidates.find(v =>
      v.option1 === currentVariant.option1 &&
      v.option2 === currentVariant.option2 &&
      v.option3 === currentVariant.option3
    );

    // Step 5: Redirect if a match is found
    if (matchedVariant) {
      window.location.href = `/products/${selectedHandle}?variant=${matchedVariant.id}`;
    } else {
      console.warn('No matching variant found for baseSku:', baseSku, 'on product:', selectedHandle);
    }
  });
});




  // Keep selection between variants on vision series
  const isSplit = document.querySelector('[data-split-product]');
  if (!isSplit) return;
  
  const $optionsSelect = document.querySelectorAll('options-selection select');
  const $secondaryOptions = document.querySelectorAll('[data-variant-option-index="2"] input');

  const $productSection = document.querySelector('[data-product-fade]');
  $productSection.classList.remove('loaded');
  
  const state = JSON.parse(localStorage.getItem("optionSelections")) || {};
  
  $optionsSelect.forEach(($option) => $option.addEventListener('change', (e) => {
    setTimeout(() => {
      state[e.target.id] = e.target.value;
      state['selectedSlide'] = document.querySelector('.gallery-navigation--scroller [data-gallery-selected="true"]').dataset.galleryIndex;
      console.log(e.target)
      localStorage.setItem("optionSelections", JSON.stringify(state));
    }, 200);
  }));
  
  $secondaryOptions.forEach(($option) => $option.addEventListener('change', (e) => {
    setTimeout(() => {
      state['secondaryOption'] = e.target.value;
      localStorage.setItem("optionSelections", JSON.stringify(state));
    }, 200);
  }));

  if (state != {}) {
    let hasSecondaryOption = false;
    for (let key in state) {
      if (key == 'secondaryOption') {
        hasSecondaryOption = true;
      } else if (key == 'selectedSlide') {
        setTimeout(() => {
          const slideToSwipe = `.gallery-navigation--scroller [data-gallery-index="${state[key]}"]`;
          document.querySelector(slideToSwipe)?.click();
        }, 2000)
      } else if (key == 'template--17431460610283__main-data-variant-option-0') {
        setTimeout(() => {
          const isOnOptions = Array.from(document.getElementById(key).options).find(option => option.label == state[key]);
          if (!isOnOptions) {
            document.getElementById(key)?.options[0]?.click();
          } else {
            document.getElementById(key).value = state[key];
            document.getElementById(key)?.click();
          }
        }, 700);
      } else {
        setTimeout(() => {
          document.getElementById(key).value = state[key];  
        }, 700)
      }
    }    

    setTimeout(() => {
      document.querySelectorAll('[data-secondary-option]').forEach(($secondaryOption) => {
        $secondaryOption.click()
      });
      document.querySelector('[data-secondary-option]').click();
      if (hasSecondaryOption) {
        document.querySelector(`[data-secondary-option="${state['secondaryOption']}"]`).click();
      }
      window.scrollTo({
        top: 0,
        left: 0
      });
    }, 700);

    setTimeout(() => {
      // Add price to the ATC button
      const $atcButton = document.querySelector('[data-product-atc]');
      const price = document.querySelector('[data-price]').innerHTML;

      if (price !== '$0') {
        $atcButton.innerHTML = `Add to cart ${price}`;
      }

      // Add opacity
      $productSection.classList.add('loaded');
    }, 1000)
  }
}
});

